import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdSearch, MdVisibility } from "react-icons/md";
import { FaDownload, FaSearch } from "react-icons/fa";
import { getCustomerListRequest } from "../../redux/actions/customerActions";
import Pagination from "../../helper/Pagination";
import CustomerOffcanvas from "../../helper/CustomerOffcanvas";
import "../../styles/InputSheet.css";

const Customer = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const oemId = user?.oemPartner?.id;
  const { loading, customers, totalCount, error } = useSelector(
    (state) => state?.customer
  );
  const handleViewDetails = (customer) => {
    setSelectedCustomer(customer);
    setShowOffcanvas(true);
  };
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  useEffect(() => {
    if (oemId) {
      dispatch(getCustomerListRequest({ oemId, search, page, limit }));
    }
  }, [dispatch, oemId, search, page, limit]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  if (loading && customers.length === 0) {
    return (
      <div className="page-container">
        <div className="page-card">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                border: "4px solid #f3f3f3",
                borderTop: "4px solid #667eea",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                marginBottom: "20px",
              }}
            ></div>
            <p style={{ color: "#7f8c8d", fontSize: "16px" }}>
              Loading Users...
            </p>
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-card scroll-container">
        <div
          className="mt-2 d-flex align-items-end justify-content-between"
          style={{ padding: "0 20px" }}
        >
          <div>
            <p style={{ color: "black", margin: "5px 0 0 0" }}>
              Total Users: {totalCount}
            </p>
          </div>
          {/* Search Bar */}
          <div className="position-relative d-flex justify-content-end">
            <input
              type="search"
              placeholder="Search scans...."
              className="form-input"
              value={search}
              onChange={handleSearch}
              style={{ width: "220px" }}
            />
            {search === "" && (
              <div
                className="position-absolute"
                style={{
                  top: "50%",
                  right: "13px",
                  transform: "translateY(-50%)",
                  color: "#666",
                }}
              >
                <FaSearch />
              </div>
            )}
          </div>
        </div>

        {/* Customer Table */}
        <div className="input-form-section">
          <div className="table-scroll-wrapper">
            <table className="partners-table">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Date/Time</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Domain</th>
                  <th>Email Verified</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="12"
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#666",
                      }}
                    >
                      <div className="loading-spinner">
                      </div>
                    </td>
                  </tr>
                ) : customers.length === 0 ? (
                  <tr>
                    <td
                      colSpan="8"
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#666",
                      }}
                    >
                      No users added yet
                    </td>
                  </tr>
                ) : (
                  customers
                    .filter((customer) => customer && customer.email)
                    .map((customer, index) => (
                      <tr key={`${customer._id}-${index}`}>
                        <td>{(page - 1) * limit + index + 1}</td>
                        <td>
                          {customer.createdAt &&
                          !isNaN(new Date(customer.createdAt))
                            ? new Date(customer.createdAt).toLocaleString([], {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: true,
                              })
                            : "---"}
                        </td>
                        <td>
                          {`${customer.firstName || ""} ${
                            customer.lastName || ""
                          }`.trim() || "N/A"}
                        </td>
                        <td>{customer.email || "N/A"}</td>
                        <td>{customer.domain || "N/A"}</td>
                        <td>
                          <span
                            className={`status-badge ${
                              customer.verified ? "verified" : "unverified"
                            }`}
                          >
                            {customer.verified ? "Verified" : "Unverified"}
                          </span>
                        </td>
                        <td>
                          <div className="row-actions">
                            <MdVisibility
                              onClick={() => handleViewDetails(customer)}
                              className="info_pointer fs-5"
                              title="View Details"
                            />
                          </div>
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </table>
          </div>

          <Pagination
            currentPage={page}
            totalPages={Math.ceil(totalCount / limit)}
            totalItems={totalCount}
            itemsPerPage={limit}
            onPageChange={setPage}
          />
        </div>
      </div>

      <CustomerOffcanvas
        show={showOffcanvas}
        onClose={() => setShowOffcanvas(false)}
        customer={selectedCustomer}
      />
    </div>
  );
};

export default Customer;
